import ApplicationV1Adapter from 'uplisting-frontend/adapters/application-v1';

export default class ExternalIcalAdapter extends ApplicationV1Adapter {
  retry(id: string): Promise<object> {
    const url = `${this.buildURL('external-ical', id)}/retry`;

    return this.ajax(url, 'POST') as Promise<object>;
  }
}

declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    'external-ical': ExternalIcalAdapter;
  }
}
